import { type RootState } from "~/redux/store";

export const saActiveTab = (state: RootState) => state.sa.activeTab;
